module.exports = __webpack_public_path__ + "img/vpc4.5c43ecc.png";